import { NavLink } from 'react-router-dom';
import { ReactComponent as HomeIcon } from 'Components/UI_Library/Icons/Home.svg';

type ClassNameProps = {
    navLink?: string;
    navIcon?: string;
    navText?: string;
};
type Props = {
    classNames: ClassNameProps;
};

const Home = (props: Props) => {
    const { navLink: navLinkClassName, navIcon: iconClassName, navText: textClassName } = props.classNames;

    return (
        <NavLink className={navLinkClassName} title="Home" to="/home">
            <div className={iconClassName}>
                <HomeIcon />
            </div>
            <span className={textClassName}>Home</span>
        </NavLink>
    );
};

export default Home;
